/*
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

import { useCSS } from '../../provider/CSSProvider';
import style from './SideBar.scss?inline';

import PatientRecord from './PatientRecord/PatientRecord';
import PatientEducation from './PatientEducation/PatientEducation';
import { Events } from './Events/Events';
import { Divider } from '@mui/material';

function SideBar() {
  useCSS(style);

  return (
    <div id='SideBar'>
      <PatientRecord />
      <Divider variant='fullWidth' />
      <PatientEducation />
      <Divider variant='fullWidth' />
      <Events />
    </div>
  );
}

export default SideBar;
